import React from 'react';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Section from 'components/Section';
import { Col, Container, Row } from 'react-bootstrap';

const PartnersAndCollaborationsPage = () => {
    return (
        <>
            <Header />
            <Section
                scheme="white"
                paddingVertical="pt-5"
            >
                <Container>
                    <div className="page-title">Đối tác & Hợp tác</div>
                    <div className="mt-4 page-content">
                        <div className="sub-heading">
                            Đối tác thiết bị y tế & Tổ chức y tế
                        </div>
                        <Row>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/1.webp" />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/2.webp" />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/3.webp" />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/4.webp" />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/5.webp" />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/6.webp" />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/7.webp" />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/8.webp" />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/9.webp" />
                                </div>
                            </Col>

                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/10.webp" />
                                </div>
                            </Col>

                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/11.webp" />
                                </div>
                            </Col>

                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img src="/partner/12.webp" />
                                </div>
                            </Col>
                        </Row>
                        <div className="sub-heading mt-5">Bệnh viện</div>
                        <Row>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/1.webp"
                                        alt="Trường Đại học Y Dược Cần Thơ"
                                    />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/2.webp"
                                        alt="Bệnh viện Đa khoa Thanh Vũ Medic Bạc Liêu"
                                    />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/3.webp"
                                        alt="Bệnh viện Tim mạch An Giang"
                                    />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/4.webp"
                                        alt="Bệnh viện Đa khoa Khu vực tỉnh An Giang"
                                    />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/5.webp"
                                        alt="Bệnh viện Đa khoa Quốc tế S.I.S Cần Thơ"
                                    />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/6.webp"
                                        alt="Bệnh viện Đa khoa Thành phố Cần Thơ"
                                    />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/7.webp"
                                        alt="Bệnh viện Đại học Y Dược TP.HCM"
                                    />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/8.webp"
                                        alt="Bệnh viện Chợ Rẫy"
                                    />
                                </div>
                            </Col>
                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/9.webp"
                                        alt="Bệnh viện Đa khoa Trung ương Cần Thơ"
                                    />
                                </div>
                            </Col>

                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/10.webp"
                                        alt="Bệnh viện Đa khoa tỉnh Sóc Trăng"
                                    />
                                </div>
                            </Col>

                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/11.webp"
                                        alt="Bệnh viện Quân Y 121"
                                    />
                                </div>
                            </Col>

                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/12.webp"
                                        alt="Bệnh viện Nguyễn Đình Chiểu"
                                    />
                                </div>
                            </Col>

                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/13.webp"
                                        alt="Bệnh viện Tim mạch Thành phố Cần Thơ"
                                    />
                                </div>
                            </Col>

                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/14.webp"
                                        alt="Bệnh viện Đa khoa tỉnh Vĩnh Long"
                                    />
                                </div>
                            </Col>

                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/15.webp"
                                        alt="Bệnh viện Hoàn Mỹ Cửu Long"
                                    />
                                </div>
                            </Col>

                            <Col
                                xs={6}
                                md={4}
                                lg={3}
                            >
                                <div className="partner-tile">
                                    <img
                                        src="/hospital/16.webp"
                                        alt="Bệnh viện Đa khoa tỉnh Trà Vinh"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <hr className="footer-divider" />
                </Container>
            </Section>
            <Footer />
        </>
    );
};

export default PartnersAndCollaborationsPage;
